import { render } from "./createQuickly.vue?vue&type=template&id=03353bb3&scoped=true"
import script from "./createQuickly.vue?vue&type=script&lang=js"
export * from "./createQuickly.vue?vue&type=script&lang=js"

import "./createQuickly.vue?vue&type=style&index=0&id=03353bb3&lang=less&scoped=true"
import "./createQuickly.vue?vue&type=style&index=1&id=03353bb3&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03353bb3"]])

export default __exports__